import { render } from "./ResourceTableRow.vue?vue&type=template&id=aa024498"
import script from "./ResourceTableRow.vue?vue&type=script&lang=js"
export * from "./ResourceTableRow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourceTableRow.vue"]])

export default __exports__